import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { fs } from "config/FsConfig";
import IssueData from "../../Scripts/AppServiceContract/IssueData";
import { IssueStatusEnum, IssueTypeEnum } from "../../Resources/Enums";
import { ValidationRules } from "aurelia-validation";
import FileInfoData from '../../../Core/Scripts/FileInfoData';
import UploadFileAppService from '../../Scripts/AppServiceContract/UploadFileAppService';
import PublicIssueAppService from "../../Scripts/AppServiceContract/PublicIssueAppService";
import { useView, autoinject, Container, computedFrom } from 'aurelia-framework';
import { PLATFORM } from 'aurelia-pal';
import { I18N } from 'aurelia-i18n';
import { EventAggregator } from 'aurelia-event-aggregator';

@autoinject()
@useView(PLATFORM.moduleName("./FondueSearchView.html"))
export default class FondueEditorVM extends EditorVMBase {

  Id: string;
  Title: string;
  Description: string;
  RequestorName: string;
  RequestorEmail: string;
  RequestorPhone: string;
  IssueDate: Date;
  Status: any;
  FileInfoList: any;
  IssueType: any;
  DescriptionDisplay: string;

  public i18n: I18N;
  public Container: Container;
  public UploadFileAppService: UploadFileAppService;
  public ServiceBaseUrl: string;
  public name: string;
  public Obj: any;
  SelectFile: any;
  Errormsg: string;
  AttachmentBaseUrl: string;
  message: any;
  Rules: any;
  validate: boolean;
  TextSubject: string;
  TextDetail: string;
  TextSelectFile: string;
  TextName: string;
  TextTelephone: string;

  eventAggregator: any;
  changeLocaleSubscribe: any;

  constructor(container: Container, i18n: I18N, eventAggregator: EventAggregator,) {
    super();
    this.Container = container;
    this.i18n = i18n;
    this.AttachmentBaseUrl = fs.Config.ServiceBaseUrl + "modules/Aqs.AppService/UploadFileAppService/DownloadFile/id=";
    this.ServiceBaseUrl = fs.Config.ServiceBaseUrl;
    var self = this;

  
  }



/*  CreateRequest(): IssueData {
    const criteria = new IssueData();
    criteria.Id = this.Id
    criteria.Title = this.Title;
    criteria.Description = this.Description;
    criteria.IssueDate = new Date();
    criteria.RequestorName = this.RequestorName;
    criteria.RequestorEmail = this.RequestorEmail;
    criteria.RequestorPhone = this.RequestorPhone;
    criteria.Status = IssueStatusEnum.New;
    criteria.IssueType = IssueTypeEnum.Public;
    criteria.FileInfoList = this.FileInfoList;
    return criteria;
  }*/

/*  Save(doneCallback: () => void, failCallback: (error: any) => void) {
    var self = this;
    this.validationController.validate().then((result) => {
      this.validate = result.valid;
      if (result.valid) {
        var request = this.CreateRequest();
        var service = Container.instance.get(PublicIssueAppService) as PublicIssueAppService;
        service.Add(request)
          .done((result) => {
            FsUtility.AlertModal("ส่งข้อมูลเรียบร้อย", 2, 1);
            this.ResetData();
            self.Id = result;
          }).fail(FsUtility.CommonErrorHandler);
      }
    })
  };*/

 /* async OnSelectFile(selectedFiles) {
    var self = this;
    var listfile = [];
    var files = selectedFiles.target.files;
    for (var x = 0; x < files.length; x++) {
      var data = new FormData();
      data.append("file" + x, files[x]);

      var File = await $.ajax({
        type: "POST",
        url: this.ServiceBaseUrl + "modules/Aqs.AppService/UploadFileAppService/UpLoad",
        contentType: false,
        processData: false,
        data: data,
        async: false,
      });
      this.Obj = { ...this.Obj, File: File.FileName, FileName: files[x].name }
      this.SelectFile = files[x];
      listfile.push(self.Obj)
    };
    this.ImportFile(listfile);
  }*/

/*  async ImportFile(obj) {
    var self = this;
    var list = [];
    for (var i = 0; i < obj.length; i++) {
      try {
        var service = Container.instance.get(UploadFileAppService) as UploadFileAppService;
        await service.UpdateAttachment(obj[i])
          .done((result) => {
            for (var i = 0; i < result.length; i++) {
              const data = new FileInfoData();
              data.Id = result[i].Id;
              data.FileName = result[i].FileName;
              data.FilePath = result[i].FilePath;
              data.Extension = result[i].Extension;
              data.ExtensionId = result[i].ExtensionId;
              data.MimeType = result[i].MimeType;
              data.Description = result[i].Description;
              data.FilePath = result[i].FilePath;
              data.RelationId = result[i].RelationId;
              data.RelationTypeValue = result[i].RelationTypeValue;
              list.push(data);
            }
          }).fail((error) => {
            FsUtility.AlertErrorMessage(error);
          });
      } catch (err) {
        FsUtility.AlertErrorMessage(err);
      }
    }
    self.FileInfoList = list;
  }*/

/*  async ValidateBeforeSave() {
    var self = this;
    this.validationController.removeObject(this);
    this.Validate();
    this.validationController.addObject(this, this.Rules);

    let res = await this.validationController.validate()
      .then(result => {
        if (!result.valid) {
          var erorrMsg = self.SetValidate(result);
          if (erorrMsg != "")
            FsUtility.AlertModal(erorrMsg, 1, 2, 3);
        }
        return result.valid;
      });

    return Promise.resolve(res);
  }*/

/*  SetValidate(error) {
    var errors = "";
    var errorsData = error.results.filter(t => t.valid == false);

    for (var i = 0; i < errorsData.length; i++) {
      if (errorsData[i].rule.property.displayName == null || errorsData[i].rule.property.displayName == "")
        errors += errorsData[i].message + "</br>";
    }
    return errors;
  }*/

/*  ResetData() {
    this.Id = null;
    this.Title = null;
    this.Description = null;
    this.RequestorName = null;
    this.RequestorEmail = null;
    this.RequestorPhone = null;
    this.IssueDate = null;
    this.Status = null;
    this.FileInfoList = null;
    this.IssueType = null;
    this.DescriptionDisplay = null;
    this.SelectFile = null;
    this.Obj = null;
  }*/

  /*@computedFrom('validationController.errors.length', 'Title')
  get TitleErrors() {
    return this.getValidateErrors('Title');
  }
  @computedFrom('validationController.errors.length', 'Description')
  get DescriptionErrors() {
    return this.getValidateErrors('Description');
  }
  @computedFrom('validationController.errors.length', 'RequestorName')
  get RequestorNameErrors() {
    return this.getValidateErrors('RequestorName');
  }
  @computedFrom('validationController.errors.length', 'RequestorEmail')
  get RequestorEmailErrors() {
    return this.getValidateErrors('RequestorEmail');
  }*/
}
